import * as React from 'react';
import SimpleBar from 'simplebar-react';
import * as classnames from 'classnames';

export interface ISimpleBarProps {
    scrollToTop?: boolean;
    forceVisible?: boolean;
    id?: string;
    className?: string;
}

export interface ISimpleBarState {
    scrollToTop: boolean;
}

export class SimpleBarWrapper extends React.Component<ISimpleBarProps, ISimpleBarState> {
    private scrollTopBtn: any;

    constructor(props: ISimpleBarProps) {
        super(props);
        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.updateScrollPosition = this.updateScrollPosition.bind(this);
        this.state = { scrollToTop: false };
    }

    handleScrollTop() {
        $(this.scrollTopBtn).closest(".simplebar-scroll-content").animate({ scrollTop: 0 }, 200);
    }

    updateScrollPosition() {
        let $element = $(this.scrollTopBtn).closest(".simplebar-scroll-content");
        if ($element.length) {
            this.setState({ scrollToTop: $element.get(0).scrollTop > 50 });
        }
    }

    render() {
        return <SimpleBar id={this.props.id} className={this.props.className} data-simplebar-force-visible={this.props.forceVisible}>
            <React.Fragment>
                {this.props.children}
                {this.props.scrollToTop &&
                    __IsMTSTipos__ ?
                    <div className={classnames(" floating-buttons floating-buttons--light", { "active": this.state.scrollToTop }, { "d-none": !this.state.scrollToTop })}>
                        <div className="floating-buttons__container">
                            <a className="floating-buttons__item cursor-pointer" ref={ref => this.scrollTopBtn = ref} onClick={this.handleScrollTop}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="floating-buttons__item-icon">
                                    <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />
                                </svg>
                                <span className="floating-buttons__item-label">Hore</span>
                            </a>
                        </div>
                    </div>
                    :
                    <div className={classnames("scroll-top-btn", { __IsMTSTipos__: "floating-buttons floating-buttons--light" }, { "show-up": this.state.scrollToTop }, { "d-none": !this.state.scrollToTop })} ref={ref => this.scrollTopBtn = ref} onClick={this.handleScrollTop}>
                        <i className="fas fa-chevron-circle-up"></i>
                    </div>
                }
            </React.Fragment >
        </SimpleBar >
    }

    componentDidMount() {
        this.props.scrollToTop &&
            $(this.scrollTopBtn).closest(".simplebar-scroll-content")[0].addEventListener('scroll', this.updateScrollPosition);
    }
}
